/* eslint-disable no-undef */
import $ from 'jquery';
import { DynamicCalls } from './dynamicCalls';
import { Utils } from './utils';

export class Charts {
    private readonly _queue: DynamicCalls;

    public constructor() {
        this._queue = new DynamicCalls();

        this._init();
    }

    private _init() {
        this._ChartsOrder();
        this._ChartsProductsMix();
        this._ChartsIntakes();
        this._GlobalStats();

        this._queue.execute();
    }

    private _GlobalStats(): void {
        let block: any = '';

        const block_customer = $('#block-dewenir-intranet-customer-global-stats');
        if (block_customer.length > 0) block = block_customer;

        const block_comercial = $('#block-dewenir-intranet-comercial-global-stats');
        if (block_comercial.length > 0) block = block_comercial;

        if (block.length === 0) {
            return;
        }

        const url = block.attr('data-source');
        const id = block.attr('data-source-id');

        let cookieName = 'intranet.global.stats';
        if (id) {
            cookieName += '.' + id;
        }

        if (!url) return;

        const callback = (response: any) => {

            block.find('#facturacion-ano').html(
                typeof response.i_year_amount !== 'undefined'
                    ? Utils.parseNumber(response.i_year_amount, true)
                    : "0.00€"
            );

            block.find('#facturacion-ultimo-mes').html(
                typeof response['i_month_-1_amount'] !== 'undefined'
                    ? Utils.parseNumber(response['i_month_-1_amount'], true)
                    : "0.00€"
            );

            block.find('#facturacion-1-ano').html(
                typeof response['i_year_-1_amount'] !== 'undefined'
                    ? Utils.parseNumber(response['i_year_-1_amount'], true)
                    : "0.00€"
            );

            block.find('#facturacion-2-ano').html(
                typeof response['i_year_-2_amount'] !== 'undefined'
                    ? Utils.parseNumber(response['i_year_-2_amount'], true)
                    : "0.00€"
            );

            Utils.storeDataInCookie(cookieName, JSON.stringify(response), location.href);
        }

        const storedData = Utils.getDataFromCookie(cookieName);

        if (storedData) {
            callback(JSON.parse(storedData));

            return;
        }

        this._queue.add({ url, callback });
    }

    private _ChartsOrder(): void {
        const block = $('#block-dewenir-intranet-customer-charts-orders');
        if (block.length === 0) {
            return;
        }

        const url = block.attr('data-source');
        const id = block.attr('data-source-id');

        let cookieName = 'intranet.orders';
        if (id) {
            cookieName += '.' + id;
        }

        if (!url) return;

        const callback = (response: any) => {
            google.charts.load("current", { packages: ["corechart"] });
            google.charts.setOnLoadCallback(() => {
                const container = block.find('.chart-area');

                const table_data = new google.visualization.DataTable();

                const response_header = response[0];
                const response_rows = response.slice([1])

                const rows_data: any[] = [];

                const getfieldTooltip = (row: Array<number>, index: number) => {

                    return `
                    <div style="padding:10px; min-width:150px">
                        <div style="margin-bottom: 5px; text-transform:capitalize;">${row[0]} - ${response_header[index]}</div>
                        <div style="margin-bottom: 5px"><strong>${Utils.parseNumber(row[index])}</strong></div>
                        <div><strong> ${row[index + 1]} ${Drupal.t('pedidos')}</strong></div>
                    </div>
                `;
                }

                response_rows.forEach(row => {
                    const row_data = row;
                    const num_mes_string = row_data[0].toString();

                    const date = new Date();
                    date.setDate(1) // algunos meses tiene más días que otros y si no se pone el primer día podría haber un cambio de mes inesperado
                    date.setMonth(num_mes_string - 1) // enero = 0

                    const monthName = Intl.DateTimeFormat(Utils.getLangcode(), { month: 'long' }).format(date);
                    row_data[0] = Drupal.t(monthName.charAt(0).toUpperCase() + monthName.slice(1));

                    row_data[2] = getfieldTooltip(row_data, 1);
                    row_data[4] = getfieldTooltip(row_data, 3);
                    row_data[6] = getfieldTooltip(row_data, 5);

                    rows_data.push(row_data);
                });

                table_data.addColumn('string', 'Month');
                table_data.addColumn('number', response_header[1]);
                table_data.addColumn({ type: 'string', role: 'tooltip', p: { 'html': true } });
                table_data.addColumn('number', response_header[3]);
                table_data.addColumn({ type: 'string', role: 'tooltip', p: { 'html': true } });
                table_data.addColumn('number', response_header[5]);
                table_data.addColumn({ type: 'string', role: 'tooltip', p: { 'html': true } });

                table_data.addRows(rows_data);

                var options = {
                    legend: { position: 'top', alignment: 'center' },
                    chartArea: {
                        height: '80%',
                        width: '90%',
                    },
                    colors: ['#ffb520', '#ff3c00', '#0d47a1'],
                    tooltip: {
                        isHtml: true,
                    }
                };

                var chart = new google.visualization.LineChart(container.get(0));
                chart.draw(table_data, options);
            });

            Utils.storeDataInCookie(cookieName, JSON.stringify(response), location.href);
        }

        const storedData = Utils.getDataFromCookie(cookieName);

        if (storedData) {
            callback(JSON.parse(storedData));

            return;
        }

        this._queue.add({ url, callback });
    }

    private _ChartsProductsMix(): void {
        const block = $('#block-dewenir-intranet-customer-charts-products-mix');
        if (block.length == 0) {
            return;
        }

        const url = block.attr('data-source');
        const id = block.attr('data-source-id');

        let cookieName = 'intranet.products.mix';
        if (id) {
            cookieName += '.' + id;
        }

        if (!url) return;

        const callback = (response: any) => {
            google.charts.load("current", { packages: ["corechart"] });
            google.charts.setOnLoadCallback(function () {
                const container = block.find('.chart-area');

                const table_data = new google.visualization.DataTable();

                const response_header = response[0];
                const response_rows = response.slice([1])

                const rows_data: any[] = [];

                const getfieldTooltip = (row: Array<number>, index: number) => {
                    return `
                    <div style="padding:10px; min-width:150px">
                        <div style="margin-bottom: 5px; text-transform:capitalize;">${row[0]} - ${response_header[index]}</div>
                        <div style="margin-bottom: 5px"><strong>${Utils.parseNumber(row[index], true)}</strong></div>
                        <div><strong> ${Utils.parseNumber(row[index + 1])} ${Drupal.t('unidades')}</strong></div>
                    </div>
                `;
                }

                response_rows.forEach(row => {
                    const row_data = row;
                    row_data[2] = getfieldTooltip(row_data, 1);
                    row_data[4] = getfieldTooltip(row_data, 3);

                    rows_data.push(row_data);
                });

                table_data.addColumn('string', Drupal.t(response_header[0]));
                table_data.addColumn('number', Drupal.t('Guantes'));
                table_data.addColumn({ type: 'string', role: 'tooltip', p: { 'html': true } });
                table_data.addColumn('number', Drupal.t('Ropa'));
                table_data.addColumn({ type: 'string', role: 'tooltip', p: { 'html': true } });

                table_data.addRows(rows_data);

                const options = {
                    legend: { position: 'top', alignment: 'center' },
                    animation: { duration: 500, easing: 'inAndOut', startup: true },
                    theme: 'material',
                    chartArea: { width: '70%' },
                    isStacked: 'percent',
                    hAxis: {
                        minValue: 0,
                    },
                    colors: ['#1F3F94', '#FCC10C'],
                    tooltip: {
                        isHtml: true,
                    }
                };

                if ($(window).width() < 768) {
                    options.chartArea.width = '90%';
                }

                var chart = new google.visualization.BarChart(container.get(0));
                chart.draw(table_data, options);
            });

            Utils.storeDataInCookie(cookieName, JSON.stringify(response), location.href);
        }

        const storedData = Utils.getDataFromCookie(cookieName);

        if (storedData) {
            callback(JSON.parse(storedData));

            return;
        }

        this._queue.add({ url, callback });
    }

    private _ChartsIntakes(): void {
        const block_gloves = $('#block-dewenir-intranet-customer-charts-gloves');
        if (block_gloves.length > 0) {
            this._displayIntakesChart(block_gloves, '#3b82ec', 'guantes');
        }

        const block_clothing = $('#block-dewenir-intranet-customer-charts-clothing');
        if (block_clothing.length > 0) {
            this._displayIntakesChart(block_clothing, '#ecb13b', 'ropa');
        }
    }

    private _displayIntakesChart(block: JQuery<Element>, color: string, productType: string): void {
        const url = block.attr('data-source');
        const id = block.attr('data-source-id');

        let cookieName = 'intranet.intakes.' + productType;
        if (id) {
            cookieName += '.' + id;
        }

        if (!url) return;

        const callback = (response: any) => {
            google.charts.load("current", { packages: ["corechart"] });
            google.charts.setOnLoadCallback(function () {
                const container = block.find('.chart-area');

                const table_data = new google.visualization.DataTable();

                table_data.addColumn('string', Drupal.t('Referencia'));
                table_data.addColumn('number', Drupal.t('Cantidad'));
                table_data.addColumn({ type: 'string', role: 'tooltip', 'p': { 'html': true } });
                table_data.addColumn({ role: 'style' });

                const rows_data: any[] = [];

                response.forEach(row => {
                    const row_data = row;
                    row_data[2] = `
                      <div style="padding:10px; min-width:150px">
                          <div>${Drupal.t('Referencia')}</div>
                          <div style="margin-bottom: 5px"><strong>${row_data[0]}</strong></div>
                          <div>${Drupal.t('Cantidad')}</div>
                          <div style="margin-bottom: 5px"><strong>${Utils.parseNumber(row_data[1])}</strong></div>
                          <div>${Drupal.t('Total')}</div>
                          <div><strong>${row_data[2]}</strong></div>
                      </div>
                  `;
                    row_data[3] = color;
                    rows_data.push(row_data);
                });

                table_data.addRows(rows_data);

                const options = {
                    legend: { position: 'none' },
                    chartArea: {
                        height: '90%',
                        top: 0,
                    },
                    bar: { groupWidth: "90%" },
                    tooltip: {
                        isHtml: true,
                    }
                };

                var chart = new google.visualization.BarChart(container.get(0));
                chart.draw(table_data, options);
            });

            Utils.storeDataInCookie(cookieName, JSON.stringify(response), location.href);
        }

        const storedData = Utils.getDataFromCookie(cookieName);

        if (storedData) {
            callback(JSON.parse(storedData));

            return;
        }

        this._queue.add({ url, callback });
    }
}
